import { InputTool, inputTools } from './definitions';

export type { InputTool };
export { inputTools };

/**
 * Get the currently active tool based on parameter values
 * @param parameterValues Object containing parameter key-value pairs
 * @returns The active tool or null if no tool is active
 */
export function getActiveTool(parameterValues: Record<string, any>): InputTool | null {
    for (const tool of inputTools) {
        if (parameterValues[tool.parameterKey]) {
            return tool;
        }
    }
    return null;
}

/**
 * Build the tools object for API requests
 * Only includes active tools with their values
 * @param parameterValues Object containing parameter key-value pairs
 * @returns Tools object for API request
 */
export function buildToolsPayload(parameterValues: Record<string, any>): Record<string, any> {
    const tools: Record<string, any> = {};
    
    for (const tool of inputTools) {
        const value = parameterValues[tool.parameterKey];
        if (value !== undefined && value !== null && value !== false) {
            tools[tool.parameterKey] = value;
        }
    }
    
    return tools;
}
